import { Component, Input } from "@angular/core";

@Component({
	selector: "app-ellipsis",
	templateUrl: "./ellipsis.component.html",
	styleUrls: ["./ellipsis.component.scss"],
})
export class EllipsisComponent {
	@Input() enabled = true;
	@Input() selectable = false;

	onMouseEnter(el: HTMLElement): void {
		if (!this.enabled) return;
		if (!this.isTruncated(el)) return;
		el.classList.add("hover-ellipsis");
	}

	onMouseLeave(el: HTMLElement): void {
		if (!this.enabled) return;
		el.classList.remove("hover-ellipsis");
	}

	isTruncated(el: HTMLElement): boolean {
		return el.scrollWidth > el.clientWidth;
	}
}
